import React from 'react';
import {
  SyncOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';
import { Col, VertTypography } from '@vertem-core/vertice-ds';



export const handleTrackingTextDotStatusCode = (
  trackingStatusCodeId,
  dotStatus = true,
  trackingText
) => {

  
  const statusClass = 'approved';
  return (
    <>
      {dotStatus && <Col className={`dot-status ${statusClass}`} />}{' '}
      {trackingText}
    </>
  );
};

export const handleTrackingTextStatusCode = (
  trackingStatusCodeId,
  isCurrentStepper,
  trackingText
) => {
  

  const statusClass = 'approved';

  return (
    <VertTypography.Paragraph className={`timeline-title ${statusClass}`}>
      {trackingText}
    </VertTypography.Paragraph>
  );
};

export const handleTrackingIconStatusCode = (
  trackingStatusCodeId,
  isCurrentStepper
) => {
 
  const statusIcons = {
    1: <SyncOutlined />,
    2: <CheckCircleOutlined />,
    3: <CheckCircleOutlined />,
    4: <CheckCircleOutlined />,
    5: <CheckCircleOutlined />,
    6: <CloseCircleOutlined />,
    7: <CloseCircleOutlined />,
    8: <CheckCircleOutlined />,
    9: <CheckCircleOutlined />,
    10: <CloseCircleOutlined />,
    default: <ClockCircleOutlined />,
  };

  const statusClass =  'approved';
  const statusIcon = statusIcons[trackingStatusCodeId] || statusIcons.default;

  return React.cloneElement(statusIcon, {
    className: `icon-timeline ${statusClass}`,
  });
};
